<template>
  <section class="features">
    <RichText :field="features.primary.header" class="header" />

    <div
      v-for="(feature, i) in features.items"
      :key="`feature-${i}`"
      class="feature"
    >
      <RichImage :field="feature.image" class="feature-image" />
      <div class="feature-content">
        <RichText :field="feature.title" />
        <RichText :field="feature.description" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    features: {
      type: Object,
      default: undefined
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../scss/base/colors';
@import '../scss/helpers/mixins';

.features {
  max-width: calc(23 * 60px);
  margin: 0 auto;

  .header {
    margin: 0 0 calc(2 * 30px);
    text-align: center;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      height: 5px;
      width: calc(3 * 60px);
      background: $grey-3;
      transform: translate(-50%, 100%);
    }
  }
}

.feature {
  display: flex;
  flex-direction: column;
  margin: 20px;
  background: $beige;
  border-radius: 5px;

  .feature-content {
    padding: 20px;
    ::v-deep p {
      color: $grey-2;
    }
  }

  ::v-deep .feature-image {
    width: calc(100vw - 40px);
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
}

@include breakpoint(M) {
  .features {
    .header {
      margin: 40px 0 calc(2 * 40px);
    }
  }
  .feature {
    flex-direction: row;
    margin: 40px 20px;

    .feature-content {
      padding: 20px 40px;
    }

    ::v-deep .feature-image {
      width: auto;
      max-width: calc(10 * 40px);
    }
  }
}
@include breakpoint(L) {
  .features {
    .header {
      margin: 50px 0 calc(2 * 50px);
    }
  }
  .feature {
    margin: 50px 25px;

    .feature-content {
      padding: 30px 50px;
    }

    ::v-deep .feature-image {
      max-width: calc(10 * 50px);
    }
  }
}
@include breakpoint(XL) {
  .features {
    .header {
      margin: 60px 0 calc(2 * 60px);
    }
  }
  .feature {
    margin: 60px 0;

    .feature-content {
      padding: 40px 60px;
    }

    ::v-deep .feature-image {
      max-width: calc(10 * 60px);
    }
  }
}
</style>
